import {
  ALL_CUSTOMER_LIST_ADMIN,
  ALL_CUSTOMERS,
  ALL_PROJECT_LIST,
  ALL_USER_GROUP_LIST, BENEFIT_DATA,
  COMBO_PROJECT_USER,
  PROJECT_SEARCH,
} from "Stores/actionTypes";
import ProjectService from "Services/http/endpoints/project/ProjectService";
import StatusHandler from "Helpers/StatusHandler";
import CustomerService from "Services/http/endpoints/customer/CustomerService";
import { translatorf } from "Languages/Utility/translatorf";
import showNotify from "Helpers/Notify";


export const getAllProjectCustomerList = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProjectService.getAllProjectCustomerList(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const projectsList = response.data.Value;
        dispatch({
          type: ALL_PROJECT_LIST,
          projectsList: projectsList,
          projectsListPagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const insertProject = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProjectService.insertProject(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Project_successfully_added'),
          customClass: "success"
        });
        return true;
      }
      return false;
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteProject = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProjectService.deleteProject(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Project_deleted_successfully'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};


export const updateProject = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProjectService.updateProject(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Project_information_edited_successfully'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  };
};


export const updateStateProjectUser = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProjectService.updateStateProjectUser(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('mission_accomplished'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const selectUserGroupCombo = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProjectService.selectUserGroupCombo(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updatedData = data.map((data) => {
          return {
            ...data,
            label: data.DisplayName,
            value: data.Key,
          };
        });
        dispatch({
          type: ALL_USER_GROUP_LIST,
          allUserGroupForAdmin: updatedData,
        });

        return updatedData;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const selectCustomerForAdmin = (params) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.getComboMoshtari(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updatedData = data.map((data) => {
          return {
            ...data,
            label: data.Name,
            value: data.Id,
          };
        });
        dispatch({
          type: ALL_CUSTOMER_LIST_ADMIN,
          allCustomerForAdmin: updatedData,
        });

        return updatedData;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const selectProjectComboInUser = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProjectService.selectProjectComboInUser(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;

        const updatedData = data.map((data) => {
          return {
            ...data,
            label: data.Name,
            value: data.Id,
          };
        });

        dispatch({
          type: COMBO_PROJECT_USER,
          allProjectComboUser: updatedData,
        });
        return updatedData;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const selectProjectComboWitIdCustomer = (params) => {
  return async () => {
    try {
      const response = await ProjectService.selectProjectComboWitIdCustomer(
        params
      );
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        return data.map((data) => {
          return {
            ...data,
            label: data.Name,
            value: data.Id,
          };
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getCustomerList = (params) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.getComboMoshtari(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const moshtariList = response.data.Value;
        const update = moshtariList.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        dispatch({
          type: ALL_CUSTOMERS,
          allCustomers: update,
        });
        return update;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getBenefitData = (params) => {
  return async (dispatch) => {
    try {
      const response = await ProjectService.getProjectProfit(params);
      let er = StatusHandler(response);
      if (!er.isFail) {
        const options = response.data.Value.Rows;
        const optionsInfo = response.data.Value.Info;
        dispatch({
          type: BENEFIT_DATA,
          benefitData: options,
          benefitInfo: optionsInfo,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};


export const changeProjectSearch = (projectDataSearch) => {
  return async (dispatch) => {
    dispatch({
      type: PROJECT_SEARCH,
      projectDataSearch: projectDataSearch,
    })
  }
}

export const updateUnitsOrder = (data) => {
  return async (dispatch) => {
    try {
      const response = await ProjectService.updateProjectUnitListOrder(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('SaveUnitOrderSuccessfully'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  };
};

